import React from 'react';

import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { SmileIcon } from '../../../../../icon/regular';
import { SmileIcon as SmileSolid } from '../../../../../icon/solid';
import useStyles from './styles';
import { Mood } from './types';

const GoodRecordAction = ({ mood }: Mood) => {
  const classes = useStyles();
  const isActive = mood === 'good';
  return (
    <Grid item className={clsx(classes.container, isActive && 'active')}>
      {
        mood
          ? isActive
            ? <SmileSolid className={clsx(classes.icon, classes.goodIcon)} />
            : <SmileIcon className={classes.icon} />
          : <SmileIcon className={clsx(classes.icon, classes.goodIcon)} />
      }
      Good
    </Grid>
  );
};

export default GoodRecordAction;
